import React, { useState, useEffect } from "react";
import { Button, Tabs, Form, Input, Col, Row, message, Switch } from "antd";
import TextOnlyTab from "./TextOnly";
import BrandDiv from "./brandDiv";
import defaultIcon from "../../assets/image/defaultIcon.svg";

import { addWidget } from "../../redux/Widget/WidgetActions";
import ButtonTab from "./buttonTab";
import ColorOptions, { getQuickChatContentColors } from "./ColorOptions";
import BadgeLogoPicker, { PRESET_BADGES } from "./BadgeLogoPicker";
import QuickChatTab from "./QuickChatTab";
import QuickChatPreview from "./QuickChatPreview";
import { useDispatch, useSelector } from "react-redux";
import TextArea from "antd/es/input/TextArea";

const isPresetLogo = (value) =>
  PRESET_BADGES.some((badge) => badge.id === value);

const loadImageAsBase64 = async (src, fileName = "logo.webp") => {
  const response = await fetch(src);
  const blob = await response.blob();
  const extension = blob.type?.split("/")?.[1] || "webp";
  const file = new File([blob], `${fileName}.${extension}`, {
    type: blob.type || "image/webp",
  });
  const base64 = await new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
  return { base64, file };
};

const applyPresetToState = (
  logoId,
  setSelectedLogo,
  setSelectedImagebase64,
  setSelectedImage,
) => {
  setSelectedLogo(logoId);
  const preset = PRESET_BADGES.find((badge) => badge.id === logoId);
  if (!preset?.src) {
    setSelectedImagebase64(null);
    setSelectedImage(null);
    return;
  }
  loadImageAsBase64(preset.src, logoId)
    .then(({ base64, file }) => {
      setSelectedImagebase64(base64);
      setSelectedImage(file);
    })
    .catch(() => {
      setSelectedImagebase64(null);
      setSelectedImage(null);
    });
};

const Appearance = ({ BrandToken }) => {
  const dispatch = useDispatch();
  const [bgcolor, setBgColor] = useState("");
  const [widgetPosition, setWidgetPosition] = useState(null);
  const [widgetPositionInteracted, setWidgetPositionInteracted] =
    useState(false);
  const [visitorBg, setvisitorBg] = useState("");
  const [headerLable, setheaderLable] = useState("");
  const [banner1, setbanner1] = useState("");
  const [banner2, setbanner2] = useState("");
  const [chatLabel, setchatLabel] = useState("Chat");
  const [heightchat, setheightchat] = useState(4);
  const [widthchat, setwidthchat] = useState(15);
  const [borderChat, setborderChat] = useState(50);
  const [Error, setError] = useState({
    label: "",
  });
  const [txtcolor, setTxtColor] = useState("#fff");
  const [isLabled, setisLabled] = useState(true);
  const [isIcons, setisIcons] = useState(true);
  const [selectedImage, setSelectedImage] = useState(null);
  const [titleLable, settitleLable] = useState("Let me help");
  const [bgcolorBadge, setbgcolorBadge] = useState("#2e3192");
  const [SelectedImagebase64, setSelectedImagebase64] = useState(null);
  const [oldPicture, setOldPicture] = useState(null);
  const [selectedLogo, setSelectedLogo] = useState("badge-1");
  const [activekeyid, setactivekeyid] = useState(null);
  const [tooltipHeader, setTooltipHeader] = useState(
    "You've got a new message !!",
  );
  const [isTooltipEnabled, setisTooltipEnabled] = useState(false);
  const [tooltipVisible, setTooltipVisible] = useState(true);
  const [quickChatLayout, setQuickChatLayout] = useState("image-right");
  const [quickChatMessage, setQuickChatMessage] = useState("Chat with us");
  const [quickChatBgColor, setQuickChatBgColor] = useState("#E9EBED");
  const [quickChatSameAsTheme, setQuickChatSameAsTheme] = useState(false);
  const [quickChatLogo, setQuickChatLogo] = useState("badge-1");
  const [quickChatImageBase64, setQuickChatImageBase64] = useState(null);
  const [quickChatOldPicture, setQuickChatOldPicture] = useState(null);
  const [NewData, setNewData] = useState(null);
  const [selectedTab, setSelectedTab] = useState("");
  const [previewFocus, setPreviewFocus] = useState("brand");

  const userData = useSelector((state) => state.Auth.userData);
  const usertoken = useSelector((state) => state.Auth.token);
  const data = useSelector((state) => state.WidgetReducer.widgetData);
  const widgetLoading = useSelector(
    (state) => state.WidgetReducer.widgetLoading,
  );
  const isLoading = useSelector((state) => state.WidgetReducer.isLoadingwidget);

  const badgeBg = bgcolorBadge || "#1890ff";

  const handleChangeColor = (selectedColor, hex) => {
    if (typeof selectedColor === "string") {
      setBgColor(selectedColor);
      return;
    }
    setBgColor(
      hex || selectedColor?.toHexString?.() || selectedColor?.toRgbString?.(),
    );
  };

  const quickChatPreviewBg = quickChatSameAsTheme
    ? bgcolor || quickChatBgColor
    : quickChatBgColor;

  const quickChatPreviewImage =
    quickChatImageBase64 ||
    quickChatOldPicture ||
    PRESET_BADGES.find((badge) => badge.id === quickChatLogo)?.src;

  const onSubmit = async (a) => {
    const badgeImage = SelectedImagebase64 || oldPicture || selectedLogo;
    const quickChatImage =
      quickChatImageBase64 || quickChatOldPicture || quickChatLogo;

    let data = {
      user_id: userData?._id,
      brand_token: BrandToken,
      pop_up: {
        pop_up_bgcolor: bgcolor,
        pop_up_headerLable: headerLable,
      },
      widget_position: widgetPosition || "flex-end",
      badge: {
        background_color: bgcolorBadge,
        title: titleLable,
        text_color: txtcolor,
        tooltip_header_text: isTooltipEnabled
          ? tooltipHeader
          : "You've got a new message !!",
        tooltip_enabled: isTooltipEnabled ? 1 : 0,
        image: badgeImage,
      },
      quick_chat: {
        layout: quickChatLayout,
        message: quickChatMessage,
        background_color: quickChatPreviewBg,
        same_as_theme: quickChatSameAsTheme ? 1 : 0,
        image: quickChatImage,
        ...getQuickChatContentColors(quickChatPreviewBg),
      },
      active: activekeyid,
    };
    dispatch(addWidget(data, usertoken, message));
  };

  const focusBrandPreview = () => setPreviewFocus("brand");
  const focusBadgePreview = () => setPreviewFocus("badge");
  const focusTooltipPreview = () => {
    setPreviewFocus("tooltip");
    setTooltipVisible(true);
  };

  const onChangebadge = (key) => {
    setactivekeyid(key);
    focusBadgePreview();
  };

  const handleTabClick = (tab) => {
    setSelectedTab(tab);
    focusBadgePreview();
  };

  const handleTooltipEnabled = (checked) => {
    setisTooltipEnabled(checked);
    focusTooltipPreview();
  };

  const handleImageChange = (info) => {
    if (info.file.originFileObj !== undefined) {
      setSelectedImage(info.file.originFileObj);
      const reader = new FileReader();
      reader.onload = () => {
        setSelectedImagebase64(reader.result);
        setSelectedLogo("custom");
      };
      reader.readAsDataURL(info.file.originFileObj);
    }
  };

  const handleCustomLogoUpload = (base64, file) => {
    setSelectedImage(file);
    setSelectedImagebase64(base64);
    setSelectedLogo("custom");
  };

  const handleQuickChatCustomUpload = (base64, file) => {
    setQuickChatImageBase64(base64);
    setQuickChatLogo("custom");
  };

  const handleQuickChatSelectLogo = async (logoId, src) => {
    if (logoId === "custom") {
      setQuickChatLogo("custom");
      if (quickChatOldPicture) {
        setQuickChatImageBase64(quickChatOldPicture);
      }
      return;
    }

    if (quickChatLogo === "custom" && quickChatImageBase64) {
      setQuickChatOldPicture(quickChatImageBase64);
    }

    setQuickChatLogo(logoId);
    if (!src) return;

    try {
      const { base64 } = await loadImageAsBase64(src, logoId);
      setQuickChatImageBase64(base64);
    } catch (error) {
      message.error("Failed to load preset logo");
    }
  };

  const handleQuickChatRemoveImage = () => {
    setQuickChatImageBase64(null);
    setQuickChatOldPicture(null);
    applyPresetToState(
      "badge-1",
      setQuickChatLogo,
      setQuickChatImageBase64,
      () => {},
    );
  };

  const handleSelectLogo = async (logoId, src) => {
    if (logoId === "custom") {
      setSelectedLogo("custom");
      if (oldPicture) {
        setSelectedImagebase64(oldPicture);
        setSelectedImage(null);
      }
      return;
    }

    // Keep a previously uploaded custom logo available in the Add Logo slot
    if (selectedLogo === "custom" && SelectedImagebase64) {
      setOldPicture(SelectedImagebase64);
    }

    setSelectedLogo(logoId);
    if (!src) return;

    try {
      const { base64, file } = await loadImageAsBase64(src, logoId);
      setSelectedImagebase64(base64);
      setSelectedImage(file);
    } catch (error) {
      message.error("Failed to load preset logo");
    }
  };

  const handleChangeColors = (selectedColor, hex) => {
    if (typeof selectedColor === "string") {
      setbgcolorBadge(selectedColor);
      return;
    }
    setbgcolorBadge(
      hex || selectedColor?.toHexString?.() || selectedColor?.toRgbString?.(),
    );
  };

  const handleChangeTxtColor = (selectedColor, hex) => {
    if (typeof selectedColor === "string") {
      setTxtColor(selectedColor);
      return;
    }
    setTxtColor(
      hex || selectedColor?.toHexString?.() || selectedColor?.toRgbString?.(),
    );
  };

  const previewHeader =
    tooltipHeader && String(tooltipHeader).trim()
      ? tooltipHeader.trim()
      : "You've got a new message !!";

  const badgeitems = [
    {
      key: "3",
      label: (
        <div className="chatbadgeImg" onClick={() => handleTabClick("Tab6")}>
          <p style={{ margin: 0 }}>Text Only</p>
        </div>
      ),
      children: (
        <TabPaneWrapper>
          <TextOnlyTab
            titleLable={titleLable}
            settitleLable={settitleLable}
            bgcolorBadge={bgcolorBadge}
            txtcolor={txtcolor}
            setTxtColor={setTxtColor}
            handleChangeColors={handleChangeColors}
            handleChangeTxtColor={handleChangeTxtColor}
          />
        </TabPaneWrapper>
      ),
    },
    {
      key: "5",
      label: (
        <div className="chatbadgeImg" onClick={() => handleTabClick("Tab1")}>
          <p style={{ margin: 0 }}>Chat button</p>
        </div>
      ),
      children: (
        <TabPaneWrapper>
          <ButtonTab
            bgcolorBadge={bgcolorBadge}
            handleChangeColors={handleChangeColors}
          />
        </TabPaneWrapper>
      ),
    },

    {
      key: "7",
      label: (
        <div className="chatbadgeImg" onClick={() => handleTabClick("Tab7")}>
          <p style={{ margin: 0 }}>Quick Chat</p>
        </div>
      ),
      children: (
        <TabPaneWrapper>
          <QuickChatTab
            layout={quickChatLayout}
            setLayout={setQuickChatLayout}
            message={quickChatMessage}
            setMessage={setQuickChatMessage}
            bgColor={quickChatBgColor}
            setBgColor={setQuickChatBgColor}
            sameAsTheme={quickChatSameAsTheme}
            setSameAsTheme={setQuickChatSameAsTheme}
            themeColor={bgcolor}
            selectedLogo={quickChatLogo}
            onSelectPreset={handleQuickChatSelectLogo}
            onCustomUpload={handleQuickChatCustomUpload}
            customPreview={quickChatPreviewImage}
            onRemoveImage={handleQuickChatRemoveImage}
            bgcolorBadge={bgcolorBadge}
            onChange={handleChangeColor}
          />
        </TabPaneWrapper>
      ),
    },
  ];

  useEffect(() => {
    if (data !== null) {
      setNewData(data);
      setbanner1(data?.pop_up?.pop_up_bannerFirst);
      setbanner2(data?.pop_up?.pop_up_bannerSecend);
      setheaderLable(data?.pop_up?.pop_up_headerLable);
      setvisitorBg(data?.pop_up?.pop_up_visitorBg);
      setBgColor(data?.pop_up?.pop_up_bgcolor);
      const savedPosition =
        data?.widget_position || data?.pop_up?.widget_position;
      if (
        savedPosition === "flex-start" ||
        savedPosition === "bottom-left" ||
        savedPosition === "left"
      ) {
        setWidgetPosition("flex-start");
      } else if (
        savedPosition === "flex-end" ||
        savedPosition === "bottom-right" ||
        savedPosition === "right"
      ) {
        setWidgetPosition("flex-end");
      } else {
        setWidgetPosition(null);
      }
      setWidgetPositionInteracted(false);
      settitleLable(data?.badge?.title);
      setbgcolorBadge(data?.badge?.background_color);
      setTxtColor(data?.badge?.text_color);
      setactivekeyid(data?.active);
      const badgeImage = data?.badge?.image;
      setOldPicture(
        badgeImage && !isPresetLogo(badgeImage) ? badgeImage : null,
      );
      if (isPresetLogo(badgeImage)) {
        applyPresetToState(
          badgeImage,
          setSelectedLogo,
          setSelectedImagebase64,
          setSelectedImage,
        );
      } else if (badgeImage) {
        setSelectedLogo("custom");
        setSelectedImagebase64(badgeImage);
        setSelectedImage(null);
      } else {
        applyPresetToState(
          "badge-1",
          setSelectedLogo,
          setSelectedImagebase64,
          setSelectedImage,
        );
      }
      setisTooltipEnabled(data?.badge?.tooltip_enabled);
      setTooltipHeader(data?.badge?.tooltip_header_text);
      setQuickChatLayout(data?.quick_chat?.layout || "image-right");
      setQuickChatMessage(data?.quick_chat?.message || "Chat with us");
      setQuickChatBgColor(data?.quick_chat?.background_color || "#E9EBED");
      setQuickChatSameAsTheme(Boolean(data?.quick_chat?.same_as_theme));
      const quickChatImage = data?.quick_chat?.image;
      setQuickChatOldPicture(
        quickChatImage && !isPresetLogo(quickChatImage) ? quickChatImage : null,
      );
      if (isPresetLogo(quickChatImage)) {
        applyPresetToState(
          quickChatImage,
          setQuickChatLogo,
          setQuickChatImageBase64,
          () => {},
        );
      } else if (quickChatImage) {
        setQuickChatLogo("custom");
        setQuickChatImageBase64(quickChatImage);
      } else {
        applyPresetToState(
          "badge-1",
          setQuickChatLogo,
          setQuickChatImageBase64,
          () => {},
        );
      }
    } else {
      setNewData(null);
    }
  }, [data]);

  const badgePreviewSrc =
    SelectedImagebase64 ||
    oldPicture ||
    PRESET_BADGES.find((badge) => badge.id === selectedLogo)?.src;

  const renderSelectedBadge = () => {
    if (activekeyid == 5) {
      return (
        <div
          className="badgeLogoPickerUploadImage"
          style={{
            backgroundColor: bgcolorBadge || "#2e3192",
            borderRadius: `50%`,
            border: "none",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: 55,
            width: 55,
            marginRight: 10,
          }}
        >
          <img
            src={badgePreviewSrc}
            style={{
              width: "25px",
              height: "100%",
              objectFit: "contain",
              borderRadius: "50%",
              display: "block",
            }}
            alt="Custom logo preview"
          />
        </div>
      );
    }

    if (activekeyid == 7) {
      return (
        <QuickChatPreview
          layout={quickChatLayout}
          message={quickChatMessage}
          backgroundColor={quickChatPreviewBg}
          imageSrc={quickChatPreviewImage}
        />
      );
    }

    if (activekeyid == 3) {
      return (
        <div
          className="chatbadgeCont"
          style={{ backgroundColor: `${bgcolorBadge}` }}
        >
          <div className="letHelp">
            <p style={{ color: txtcolor }}>{titleLable}</p>
          </div>
        </div>
      );
    }

    return (
      <button
        type="button"
        className="quickPreviewChatBar"
        style={{ backgroundColor: badgeBg }}
      >
        Chat With Us
      </button>
    );
  };

  return (
    <Row className="widgetAppearance" gutter={[16, 24]}>
      {widgetLoading ? (
        <div>Loading...</div>
      ) : (
        <>
          {NewData !== null ? (
            <>
              {" "}
              <Col xs={24} lg={14} className="badgeDiv">
                <div
                  onMouseDown={focusBrandPreview}
                  onFocusCapture={focusBrandPreview}
                >
                  <h6>Customize the widget to suit your brand</h6>
                  <p>(you can change this later)</p>
                  <Form
                    name="basic"
                    style={{
                      maxWidth: "100%",
                      width: "100%",
                    }}
                    initialValues={{
                      remember: true,
                    }}
                    autoComplete="off"
                  >
                    <Form.Item
                      label="Welcome Message"
                      name="headerlabel"
                      labelCol={{ span: 24 }}
                      wrapperCol={{ span: 16 }}
                      colon={false}
                      style={{ fontWeight: 600 }}
                    >
                      <TextArea
                        defaultValue={headerLable}
                        maxLength={25}
                        rows={4}
                        onChange={(e) => setheaderLable(e.target.value)}
                        style={{ fontWeight: 400 }}
                      />
                    </Form.Item>
                    <Form.Item
                      label="Color"
                      labelCol={{ span: 24 }}
                      wrapperCol={{ span: 24 }}
                      colon={false}
                      style={{ fontWeight: 600 }}
                    >
                      <ColorOptions
                        value={bgcolor}
                        onChange={handleChangeColor}
                      />
                    </Form.Item>
                    <Form.Item
                      label="Widget position"
                      labelCol={{ span: 24 }}
                      wrapperCol={{ span: 16 }}
                      colon={false}
                      className="widgetPositionItem"
                      style={{ fontWeight: 600, marginTop: 20 }}
                    >
                      <div
                        className="widgetPositionToggle"
                        role="group"
                        aria-label="Widget position"
                      >
                        <button
                          type="button"
                          className={
                            widgetPosition === "flex-start" ? "selected" : ""
                          }
                          onClick={() => {
                            setWidgetPosition("flex-start");
                            setWidgetPositionInteracted(true);
                          }}
                        >
                          Bottom left
                        </button>
                        <button
                          type="button"
                          className={
                            widgetPosition === "flex-end" ? "selected" : ""
                          }
                          onClick={() => {
                            setWidgetPosition("flex-end");
                            setWidgetPositionInteracted(true);
                          }}
                        >
                          Bottom right
                        </button>
                      </div>
                    </Form.Item>
                  </Form>
                </div>

                <div
                  style={{ marginTop: 22 }}
                  onMouseDown={focusBadgePreview}
                  onFocusCapture={focusBadgePreview}
                >
                  <div style={{ marginBottom: 10 }}>
                    <h6>Chat Badge</h6>
                  </div>
                  <Tabs
                    style={{ lineHeight: "14px", padding: 0 }}
                    defaultActiveKey={activekeyid}
                    items={badgeitems}
                    onChange={onChangebadge}
                  />

                  {activekeyid == 5 && (
                    <BadgeLogoPicker
                      selectedLogo={selectedLogo}
                      onSelectPreset={handleSelectLogo}
                      onCustomUpload={handleCustomLogoUpload}
                      customPreview={
                        selectedLogo === "custom"
                          ? SelectedImagebase64 || oldPicture
                          : oldPicture
                      }
                      bgcolorBadge={bgcolorBadge}
                    />
                  )}
                </div>
                {/* <Row> */}
                <Col xs={24} lg={16}>
                  <div
                    style={{ marginTop: 8 }}
                    onMouseDown={focusTooltipPreview}
                    onFocusCapture={focusTooltipPreview}
                  >
                    <h6>Quick Preview Tooltip</h6>
                    <Form
                      layout="vertical"
                      style={{
                        maxWidth: "100%",
                        width: "100%",
                        fontWeight: 600,
                      }}
                    >
                      <Form.Item
                        label="Tooltip Enabled"
                        style={{ marginTop: 20 }}
                      >
                        <Switch
                          checked={isTooltipEnabled}
                          onChange={(checked) => handleTooltipEnabled(checked)}
                        />
                      </Form.Item>
                      <Form.Item
                        label="Tooltip Header"
                        style={{ marginTop: 20 }}
                      >
                        <Input
                          value={tooltipHeader}
                          onChange={(e) => setTooltipHeader(e.target.value)}
                          placeholder="You've got a new message !!"
                          maxLength={35}
                        />
                      </Form.Item>
                    </Form>
                  </div>
                </Col>
                {/* </Row> */}
              </Col>
              <Col xs={24} lg={10} className="widgetAppearancePreview">
                <div className="perviewHead">
                  <h6>Preview</h6>
                </div>
                {previewFocus === "brand" && (
                  <BrandDiv
                    isTooltipEnabled={isTooltipEnabled}
                    activekeyid={activekeyid}
                    oldPicture={oldPicture}
                    tooltipHeader={tooltipHeader}
                    selectedTab={selectedTab}
                    bgcolor={bgcolor}
                    widgetPosition={
                      widgetPositionInteracted ? widgetPosition : null
                    }
                    headerLable={headerLable}
                    banner1={banner1}
                    banner2={banner2}
                    visitorBg={visitorBg}
                    chatLabel={chatLabel}
                    heightchat={heightchat}
                    widthchat={widthchat}
                    borderChat={borderChat}
                    txtcolor={txtcolor}
                    isLabled={isLabled}
                    isIcons={isIcons}
                    setchatLabel={setchatLabel}
                    setError={setError}
                    setBgColor={setBgColor}
                    setTxtColor={setTxtColor}
                    setheightchat={setheightchat}
                    setwidthchat={setwidthchat}
                    setborderChat={setborderChat}
                    setisLabled={setisLabled}
                    setisIcons={setisIcons}
                    selectedImage={selectedImage}
                    titleLable={titleLable}
                    bgcolorBadge={bgcolorBadge}
                    setbgcolorBadge={setbgcolorBadge}
                    handleImageChange={handleImageChange}
                    handleChangeColors={handleChangeColors}
                    handleChangeTxtColor={handleChangeTxtColor}
                    defaultIcon={defaultIcon}
                  />
                )}

                {previewFocus === "badge" && (
                  <div className="widgetBadgePreview">
                    {renderSelectedBadge()}
                  </div>
                )}

                {previewFocus === "tooltip" && (
                  <div className="quickPreviewTooltipWrap">
                    {tooltipVisible && isTooltipEnabled && (
                      <div className="quickPreviewTooltip">
                        <button
                          type="button"
                          className="quickPreviewTooltipClose"
                          aria-label="Close preview tooltip"
                          onClick={() => setTooltipVisible(false)}
                        >
                          ×
                        </button>
                        <div className="quickPreviewTooltipHeader">
                          {previewHeader}
                        </div>
                        <div
                          className="quickPreviewTooltipBody"
                          style={{ color: badgeBg }}
                        >
                          Hello, is anyone there ?
                        </div>
                      </div>
                    )}
                    <div className="quickPreviewChatBarWrap">
                      {renderSelectedBadge()}
                    </div>
                  </div>
                )}

                <Form.Item>
                  <Button
                    disabled={isLoading}
                    style={{ marginTop: 30 }}
                    type="primary"
                    onClick={() => onSubmit()}
                  >
                    Save Changes
                  </Button>
                </Form.Item>
              </Col>
            </>
          ) : (
            <div>No Data Found, (Please Select Website.)</div>
          )}
        </>
      )}
    </Row>
  );
};

export function TabPaneWrapper({ children, ...props }) {
  return <div {...props}>{children}</div>;
}

export default Appearance;
